// extracted by mini-css-extract-plugin
export default {"backToTopButton":"back-to-top-button_backToTopButton__oiBP5"};